import { BTd } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBTd = createEgBootstrapProxy("EgBTd", BTd);
